<template>
  <div class="licencekey">
    <div class="overlay-loader" v-if="loading">
      <div class="wrap">
        <div id="pulse1" />
        <div id="pulse2" />
      </div>
    </div>
    <b-container>
      <b-row class="py-3 align-items-center">
        <b-col md="10" sm="6">
          <div class="d-flex align-items-center justify-content-between">
            <div class="logo">
              <img src="../assets/images/zwingBlack.svg" alt="ZWING" />
            </div>
          </div>
        </b-col>
        <b-col md="2" sm="6" class="justify-content-between outline-dropdown">
          <b-dropdown
            text="WebPOS"
            disabled
            block
            variant="outline-secondary"
          />
        </b-col>
      </b-row>
    </b-container>
    <div class="login-wrapper">
      <b-container>
        <b-row>
          <b-col align-self="center" lg="5" class="mx-auto">
            <div class="text-center">
              <h2 class="">Activate Device</h2>
              <p>Register using the serial key provided to you</p>
            </div>
            <form
              @submit.prevent="setLicence"
              :class="{ 'is-loading': loading }"
            >
              <div class="input-box mt-40">
                <ZWInput
                  labelText="12-digit serial key"
                  v-model="licenceKey"
                  type="text"
                  :inputlength="12"
                  :id="'license-input'"
                  @clearError="error = ''"
                  :error="error != ''"
                />
                <!-- <template slot="icon">
                    <font-awesome-icon
                      @click="clear()"
                      :icon="['fas', 'times']"
                      class="text-danger mr-3"
                    />
                  </template> -->
                <transition name="fade">
                  <span
                    id="license-error"
                    class="invalid-feedback fs-12 pl-2"
                    v-if="error != 'authmobile'"
                    v-text="error"
                  />
                </transition>
                <!-- <label id="license-label">12-digit serial key</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="00000 00000 0000"
                  v-model="licenceKey"
                  @keyup="error = ''"
                  maxlength="12"
                  autocomplete="off"
                  :disabled="$loading"
                  v-shortkey.focus="['ctrl', 'f']"
                  id="license-input"
                />
                <span class="pr-4" v-if="licenceKey != ''">
                  <font-awesome-icon
                    @click="clear()"
                    :icon="['fas', 'times']"
                    class="f-awesome"
                  />
                </span>
                <span
                  id="license-error"
                  class="invalid-feedback"
                  v-if="error != 'authmobile'"
                  v-text="error"
                ></span>
              </div>-->
              </div>
              <div class="bottom mt-3">
                <b-button
                  type="submit"
                  size="lg"
                  block
                  :disabled="licenceKey.length != 12 || loading"
                  variant="primary"
                  class="submit-btn"
                  id="register-key"
                >
                  <span>Continue</span>
                  <!-- <b-spinner small type="grow" v-if="state.loading"></b-spinner>
                <span v-if="loading">Loading...</span> -->
                </b-button>
              </div>
            </form>
          </b-col>
        </b-row>
        <update-app-alert />
      </b-container>
    </div>
    <div v-shortkey="['ctrl', 'alt', 'shift', '~']" @shortkey="alertUdid"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import UpdateAppAlert from "../components/UpdateAppAlert";
import ZWInput from "../components/ZWInput.vue";
require("clientjs");

export default {
  name: "licence-key",
  components: {
    UpdateAppAlert,
    ZWInput,
  },
  data() {
    return {
      licenceKey: "",
      key: false,
      error: "",
      loading: false,
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    /* activeClass() {
      let check = "";
      if (this.error != "") {
        check = "is-error";
      } else if (this.$store.getters.checkLicence) {
        check = "is-success";
      }
      return check;
    },*/
  },

  mounted() {
    console.log(process.env.VUE_APP_API_URL);
  },

  // watch: {
  //   licenceKey() {
  //     this.state.loading = false;
  //     if (this.licenceKey.length == 12) {
  //       this.key = true;
  //     } else {
  //       this.key = false;
  //     }
  //   }
  // },
  methods: {
    alertUdid() {
      let client = new ClientJS();
      let ua = client.getBrowserData().ua;
      let canvasPrint = client.getCanvasPrint();

      var data =
        client.getFingerprint() +
        client.getCustomFingerprint(ua, canvasPrint).toString() +
        "#" +
        client.getOSVersion();
      alert(data);
    },
    clear() {
      this.licenceKey = "";
      this.error = "";
    },
    setLicence() {
      this.loading = true;
      let client = new ClientJS();
      let ua = client.getBrowserData().ua;
      let canvasPrint = client.getCanvasPrint();
      let data = {
        licence_no: this.licenceKey,
        udid:
          client.getFingerprint() +
          client.getCustomFingerprint(ua, canvasPrint).toString(),
        trans_from: this.state.trans_from,
        terminal_id: this.state.system.settings.terminal_id,
        url: "/cash-register/tag-licence",
      };
      // console.log(data);
      axios
        .post(data.url, data)
        .then((res) => {
          // console.log(res);
          // console.log(res.data.status);
          let country_details = {};
          if (res.data.hasOwnProperty("country_details")) {
            country_details = res.data.country_details;
          } else {
            country_details.phone_digit = 10;
            country_details.dial_code = "+91";
            country_details.country_id = 101;
          }
          if (res.data.status == "success") {
            this.$store.commit("system/getCountryDetails", country_details);
            this.$store.commit("system/setLicense", res.data);
            this.$router.push("/");
          } else if (res.data.status == "fail") {
            this.error = res.data.message;
            this.loading = false;
          }
        })
        .catch(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-dialog .modal-body .content {
  height: 400px;
  overflow: auto;
}
.licencekey {
  background: $white-color;
  height: 100vh;
  align-items: center;
  overflow: auto;
  h2 {
    letter-spacing: 1px;
  }
  p {
    color: $grey-color;
    font-size: 1rem;
  }
  // .fa-times {
  //   transition: 0.2s ease;
  //   position: relative;
  //   top: -2px;
  //   font-size: 20px;
  //   cursor: pointer;
  // }
  .login-wrapper {
    height: calc(100vh - 73px);
    display: flex;
    align-items: center;
    overflow: auto;
  }
  .invalid-feedback {
    color: $danger-dark;
    display: block;
  }
  /* .input-box {
    border-left: 4px solid #828181;
    height: 80px;
    border-radius: 0.25rem;
    padding-top: 15px;
    padding-left: 15px;
    width: 100%;
    background-color: #504d4d;
    transition: 1s all ease;
    label {
      color: $grey-color;
      font-size: 12px;
      display: block;
      margin-bottom: 0;
    }
    .form-control {
      padding: 2px;
      border-radius: 0;
      background-color: transparent;
      border: none;
      color: $grey-color;
      font-size: 0.9rem;
    }
    .form-control:focus {
      outline: none;
      box-shadow: none;
    }
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      text-indent: 1px;
      text-overflow: "";
      padding-right: 10px;
    }
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    span.invalid-feedback {
      margin-top: 19px;
      font-size: 0.9rem;
      display: block;
      color: #fa5a5a;
    }
  }
  .form-control {
    background-color: #504d4d !important;
  }*/
  // .bottom {
  //   margin-top: 70px;
  //   .btn {
  //     color: rgb(64, 64, 64);
  //     padding: 10px 50px !important;
  //     // background-color: rgb(118, 118, 118);
  //     background-color: #9e9e9e;
  //     font-size: 15px;
  //   }
  //   p {
  //     margin-top: 40px;
  //     font-size: 14px;
  //     color: rgb(118, 118, 118);
  //     a {
  //       color: $white-color;
  //     }
  //   }
  // }
  .is-error {
    border-color: $danger-dark;
  }
  .is-success {
    border-color: $green-color;
  }
}
// input:-webkit-autofill,
// input:-webkit-autofill:hover,
// input:-webkit-autofill:focus,
// input:-webkit-autofill:active {
//   -webkit-box-shadow: 0 0 0 30px #504d4d inset !important;
//   -webkit-background-color: 0 0 0 30px #504d4d inset !important;
// }
.licencekey .input-box .form-control {
  border: none !important;
}
.licencekey span .f-awesome {
  color: #f0f0f0 !important;
  cursor: pointer;
}

.licencekey .bottom .btn {
  background-color: #9e9e9e;
}
.login .bottom .btn:disabled {
  background-color: #9d9d9d4d;
}
.submit-btn {
  font-size: calc(0.75em + 1vmin);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
